import { State } from 'flow/types/State';
import { isCompanionSignallingSurface } from 'flow/companion/companion-utils';
import { COMPANION_LOCALLY_MUTED } from 'flow/constants/companion-constants';
import { getFocusedActiveCall } from './call-selectors';

// Separate from call-selectors: these need companion-utils, which already reads from it.

/**
 * What the companion last reported for the focused call, or null if it has reported nothing -
 * which is not the same as unmuted.
 */
export const selectCompanionLocallyMuted = (state: State) => {
    const activeCall = getFocusedActiveCall(state);
    if (!activeCall) {
        return null;
    }

    const reported = activeCall.getIn([
        'bagVariables',
        COMPANION_LOCALLY_MUTED,
    ]);

    if (reported === undefined || reported === null) {
        return null;
    }

    // It arrives as the string "true"/"false": bag values pass through tryParseJsonObject, which
    // hands back anything that isn't an object unchanged. The boolean arm is only a guard in case
    // that shared helper ever starts parsing scalars - the string arm is the live one.
    return reported === true || reported === 'true';
};

/**
 * Whether to show the microphone as muted: this surface's pending intent first, then what the
 * companion reported, then this client's own flag. A client that owns its media uses only the
 * last - the intent has to win first or the button flips back under the user's finger.
 */
export const selectMicIsMuted = (state: State) => {
    if (!isCompanionSignallingSurface(state)) {
        return state.phone.get('isMuted');
    }

    const pending = state.phone.get('pendingMute');
    if (pending !== null && pending !== undefined) {
        return pending;
    }

    const reported = selectCompanionLocallyMuted(state);
    if (reported !== null) {
        return reported;
    }

    return state.phone.get('isMuted');
};
